import { logError } from './logError';
import { sleep } from './sleep';

const retry = async (
  retries: number,
  fetchCandidate: () => Promise<any>,
  delayInMilliseconds = 500,
): Promise<any> => {
  try {
    return await fetchCandidate();
  } catch (error: any) {
    if (retries > 1) {
      await sleep(delayInMilliseconds);
      return retry(retries - 1, fetchCandidate, delayInMilliseconds);
    }
    logError(
      {
        errorCode: 'MANUALLY_ADD_CANDIDATE',
        description: 'Error attempting a retry: fetchCandidate',
      },
      { error },
    );
  }
};

export default retry;
